import { httpRequest } from "@services/http";
import { PopulationList } from "@models/population.model";

export class CommandSetControlGroup {
  async run(launchId: number, enabled: boolean, pct: number): Promise<PopulationList> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/population/control/`;
    return await httpRequest<PopulationList>(url, {
      method: "POST",
      body: JSON.stringify({ enabled, pct }),
    });
  }
}
